import { BLOCKS } from '@contentful/rich-text-types'
import type  { Document, Block, Inline } from '@contentful/rich-text-types'

import { documentToReactComponents, type Options } from '@contentful/rich-text-react-renderer'

import EmbeddedEntityRenderer from '@cms/renderers/embeded-entry-renderer'
import { renderMark, renderNode, renderText, secureAssetLinks, normalAssetLinks } from '@lib/rich-text-base'
import { generateBaseMediaQWidths } from '@lib/services/image-service'
import type { WidthKeys } from '@lib/services/image-service'
import clsx from 'clsx'

const widthMap = {
  '12 columns': 'lg:max-w-[75%]', // max width 8 columns
  '10 columns': 'lg:max-w-[80%]', // max width 8 columns
  '8 columns': 'lg:max-w-full',
}

const getEmbeddedEntryOptions = (width?: WidthKeys) => {
  return {
    [BLOCKS.EMBEDDED_ENTRY]: (node) => {
      let mediaQWidths = undefined
      const contentType = node.data.target.sys.contentType.sys.id

      if (contentType === 'captionedMedia') {
        mediaQWidths = generateBaseMediaQWidths(width)
      }

      return (
        <EmbeddedEntityRenderer
          embeddedEntry={node}
          extras={mediaQWidths}
          className={clsx(
            // Handle column size with max width and margin x to avoid uncessary wrappers
            'mx-auto w-full',
            // Force media/video/carousel embedded entries to have max widths.
            contentType === 'mediaCarouselBlock' && width && widthMap[width],
            contentType === 'captionedMedia' ||
              (contentType === 'campaignCaptionedMedia' && width && widthMap[width]),
            contentType === 'videoPlayer' && width && widthMap[width],
          )}
        />
      )
    },
  } as Options['renderNode']
}

export const richTextRender = (content?: Document | Block | Inline, width?: WidthKeys, secureAssets?: boolean) => {
  const embeddedEntryOptions = getEmbeddedEntryOptions(width)
  let renderNodeWithEmbeddedEntries = { ...renderNode, ...embeddedEntryOptions }
  if(secureAssets){
    renderNodeWithEmbeddedEntries = { ...renderNodeWithEmbeddedEntries, ...secureAssetLinks }
  } else {
    renderNodeWithEmbeddedEntries = { ...renderNodeWithEmbeddedEntries, ...normalAssetLinks }
  }
  const options = { renderMark, renderNode: renderNodeWithEmbeddedEntries, renderText }
  return documentToReactComponents(content as Document, options)
}

export const richTextRenderFactory = (width?: WidthKeys, secureAssets?: boolean) => (content?: Document | Block | Inline) =>
  richTextRender(content, width, secureAssets)
